module.exports = __webpack_public_path__ + "img/hardness@2x.32469d3.jpg";